import { defineMessages } from 'react-intl';

import { apiReblog, apiUnreblog } from 'mastodon/api/interactions';
import { browserHistory } from 'mastodon/components/router';
import type { StatusVisibility } from 'mastodon/models/status';
import { createDataLoadingThunk } from 'mastodon/store/typed_functions';

import { showAlert } from './alerts';
import { importFetchedStatus } from './importer';

const messages = defineMessages({
  reblogged: {
    id: 'status.relog_success',
    defaultMessage: 'Reblogged successfully',
  },
  rebloggedError: {
    id: 'status.cannot_reblog',
    defaultMessage: 'Error reblogging status',
  },
  open:{
    id: 'compose.published.open',
    defaultMessage: 'Open',
  },
  unreblogged: {
    id: 'status.unreblog',
    defaultMessage: 'Unreblog',
  },
  unrebloggedError: {
    id: 'status.unrebloggedError',
    defaultMessage: 'Error unreblogging status',
  },
});

export const reblog = createDataLoadingThunk(
  'status/reblog',
  ({
    statusId,
    visibility,
    reblog_caption,
  }: {
    statusId: string;
    visibility: StatusVisibility;
    reblog_caption?: string;
  }) => apiReblog(statusId, visibility, reblog_caption),
  (data, { dispatch, discardLoadData }) => {
    dispatch(importFetchedStatus(data));
    dispatch(
      showAlert({
        message: messages.reblogged,
        action: messages.open,
        dismiss: 10000,
        onClick: () => {
          browserHistory.push(`/@${data.account.username}/${data.id}`);
        },
      }),
    );

    return discardLoadData;
  },
);

export const unreblog = createDataLoadingThunk(
  'status/unreblog',
  ({ statusId }: { statusId: string }) => apiUnreblog(statusId),
  (data, { dispatch, discardLoadData }) => {
    dispatch(importFetchedStatus(data));
    return discardLoadData;
  },
);